export default "__VITE_ASSET__Bp2Iw0rz__"